<template>
    <div>
        <b-row>
            <b-col sm="12">       
                <b-collapse visible>
                    <p class="mb-2">
                        <label>
                            Por favor tener en cuenta que los procesos agendados solo estarán disponibles por 2 horas         
                        </label>
                        <b-button class="float-right" variant="primary" @click="reloadImportes">
                            <i class="fa fa-refresh mr-1"></i> Actualizar consulta
                        </b-button>
                    </p>
                    <b-alert show variant="info" class="mt-3">
                        <ul class="mb-0">
                            <li>Solo se permite un proceso de agendamiento activo a la vez.</li>
                            <li>Se visualizan los últimos 5 registros procesados.</li>
                        </ul>
                    </b-alert>
                    <b-table
                        class="mt-3" 
                        responsive
                        striped 
                        hover 
                        :items="importesLimitados" 
                        :fields="columnas">                    
                        
                        <template v-slot:cell(estado_procesamiento)="data">
                            <b-badge :variant="getBadgeVariant(data.item)">
                                {{ getStatusLabel(data.item) }}
                            </b-badge>
                        </template>

                        <template v-slot:cell(fecha_generacion)="data">
                            <span>{{ data.item.fecha_generacion || (data.item.estado_procesamiento === 'TERMINADO' ? 'N/A' : 'Pendiente...') }}</span>
                        </template>

                        <template v-slot:cell(tiempo_procesamiento)="data">
                            <span v-if="data.item.tiempo_procesamiento" class="text-primary font-weight-bold">
                                <i class="fa fa-clock-o mr-1"></i> {{ data.item.tiempo_procesamiento }}
                            </span>
                            <span v-else class="text-muted italic">---</span>
                        </template>

                        <template v-slot:cell(detalles)="data">
                            <b-button 
                                v-if="data.item.estado_procesamiento === 'TERMINADO' && data.item.errores" 
                                size="sm" 
                                variant="info" 
                                @click="verDetalles(data.item)">
                                <i class="fa fa-search"></i> Ver Resultados
                            </b-button>
                            <span v-else-if="data.item.estado_procesamiento === 'PROCESANDO'">
                                <i class="fa fa-spinner fa-spin"></i> Procesando...
                            </span>
                            <span v-else>-</span>
                        </template>

                        <template #empty>
                            <p class="text-muted text-center mt-3">
                                <i class="fa fa-list mr-1"></i> No hay agendamientos recientes para mostrar...
                            </p>
                        </template>

                    </b-table>       
                </b-collapse>
            </b-col>     
        </b-row>

        <!-- Modal para ver detalles/errores -->
        <b-modal id="modal-detalles-proceso" :title="'Detalles del Procesamiento' + (selectedProceso ? ' - ' + getStatusLabel(selectedProceso) : '')" size="lg" ok-only>
            <div v-if="selectedProceso">
                <b-row class="mb-3">
                    <b-col md="4">
                        <small class="text-muted d-block">Fecha Solicitud</small>
                        <strong>{{ selectedProceso.fecha_solicitud }}</strong>
                    </b-col>
                    <b-col md="4">
                        <small class="text-muted d-block">Fecha Finalización</small>
                        <strong>{{ selectedProceso.fecha_generacion || 'N/A' }}</strong>
                    </b-col>
                    <b-col md="4">
                        <small class="text-muted d-block">Resultado</small>
                        <b-badge :variant="getBadgeVariant(selectedProceso)">{{ getStatusLabel(selectedProceso) }}</b-badge>
                    </b-col>
                </b-row>
                
                <b-alert v-if="getStatusLabel(selectedProceso) === 'FINALIZADO CON ALERTAS'" show variant="warning" small>
                    <i class="fa fa-warning mr-1"></i> El proceso terminó, pero algunas filas del Excel no pudieron procesarse correctamente.
                </b-alert>
                
                <b-table 
                    v-if="parsedErrores.length > 0"
                    striped hover small responsive
                    :items="parsedErrores"
                    :fields="columnasErrores">
                    <template v-slot:cell(errors)="data">
                        <ul>
                            <li v-for="(err, idx) in data.item.errors" :key="idx" class="text-danger small">
                                {{ err }}
                            </li>
                        </ul>
                    </template>
                </b-table>
                <b-alert v-else show variant="success">
                    El proceso finalizó correctamente sin errores.
                </b-alert>
            </div>
        </b-modal>
    </div>
</template>

<script> 
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    name: 'ProductosMasivoAgendados',
    props: ['importes'],
    data() {
        return {
            selectedProceso: null,
            columnas: [
                { key: 'fecha_solicitud', label: 'Solicitud', sortable: true },
                { key: 'fecha_generacion', label: 'Finalización', sortable: true },
                { key: 'tiempo_procesamiento', label: 'Duración', sortable: true },
                { key: 'estado_procesamiento', label: 'Estado', sortable: true },
                { key: 'detalles', label: 'Acciones' }
            ],
            columnasErrores: [
                { key: 'row', label: 'Fila' },
                { key: 'name', label: 'Producto' },
                { key: 'manufacturer', label: 'Fabricante' },
                { key: 'errors', label: 'Errores/Detalles' }
            ]
        }
    },
    mounted() {
        this.$root.$on('notificacion-inventario', this.handleNotificacionInventario);
    },
    beforeDestroy() {
        this.$root.$off('notificacion-inventario', this.handleNotificacionInventario);
    },
    methods: {       
        handleNotificacionInventario(data) {
            const e = data;
            if (e.mensaje && e.mensaje.titulo && e.mensaje.titulo.toLowerCase().includes('carga de productos')) {
                this.reloadImportes();
            }
        },
        reloadImportes() {
            if (this.filterProducts.empresa) {
                this.listarImportesAgendadosProductos({ company: this.filterProducts.empresa, action: this.upFileExcelShow.action });
            }
        },
        getStatusLabel(item) {
            if (!item) return '';
            if (item.estado_procesamiento === 'TERMINADO') {
                const errores = this.parseErroresDirectly(item.errores);
                // Si hay errores en el array (filas fallidas)
                if (errores.length > 0) {
                    // Si todos fallaron o es un error de sistema
                    if (errores.some(e => e.status === 'ERROR')) return 'ERROR';
                    return 'FINALIZADO CON ALERTAS';
                }
                return 'EXITOSO';
            }
            return item.estado_procesamiento;
        },
        getBadgeVariant(item) {
            if (!item) return 'secondary';
            const estado = item.estado_procesamiento;
            if (estado === 'TERMINADO') {
                const errores = this.parseErroresDirectly(item.errores);
                if (errores.length > 0) {
                    if (errores.some(e => e.status === 'ERROR')) return 'danger';
                    return 'warning';
                }
                return 'success';
            }
            switch (estado) {
                case 'PROCESANDO': return 'primary';
                case 'AGENDADO': return 'info';
                case 'ERROR': return 'danger';
                default: return 'secondary';
            }
        },
        parseErroresDirectly(errores) {
            if (!errores) return [];
            try {
                if (Array.isArray(errores)) return errores;
                return JSON.parse(errores);
            } catch (e) {
                return [];
            }
        },
        verDetalles(item) {
            this.selectedProceso = item;
            this.$bvModal.show('modal-detalles-proceso');
        },
        ...mapActions("productos", [
            'listarImportesAgendadosProductos'
        ]),
    },
    computed: {
        ...mapState('productos', {
            filterProducts: 'filtro',
            upFileExcelShow: 'upFileExcelShow'
        }),
        ...mapState({
            user: state => state.auth.user
        }),

        parsedErrores() {
            if (!this.selectedProceso || !this.selectedProceso.errores) return [];
            try {
                if (Array.isArray(this.selectedProceso.errores)) return this.selectedProceso.errores;
                return JSON.parse(this.selectedProceso.errores);
            } catch (e) {
                console.error("Error parseando errores del proceso", e);
                return [];
            }
        },
        importesLimitados() {
            if (!this.importes) return [];
            return this.importes.slice(0, 5);
        }
    }
}

</script>

<style scoped>
</style>
